<template>
  <div class="footer">
      <small> <a href="http://www.fabianrios.co/en/proyectos" target="_blank"> Fabián Ríos </a> 2019.  Master thesis at Rhine-Waal University of Applied Sciences </small>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
      footer: 'fasa'
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.footer{
    border-top: 1px solid #cad2d3;
    text-align: right;
    padding:10px 20px;
    @media screen and (min-width: 767px) {
      padding:10px 40px;
    }
    a[target="_blank"]::after {
      top: -3px;
      width: 7px;
      height: 7px;
      margin-left: 0;
    }
}
</style>